export var ThemeSwitch;
(function (ThemeSwitch) {
    ThemeSwitch["idea"] = "idea";
    ThemeSwitch["material"] = "material";
})(ThemeSwitch || (ThemeSwitch = {}));
